import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationcabbookinginpune() {



  const cardData =
  {
    keyword: 'Outstation Cab Bookings in Pune',
    heading: 'Aaryan Travels: Outstation Cab Bookings in Pune',
    headingDescription: 'Aaryan Travels offers convenient Outstation Cab Bookings in Pune for weekend getaways, pilgrimages, corporate trips, and family vacations. Whether you’re planning a journey to Mahabaleshwar, Shirdi, Lonavala, Goa, Nashik, or Kolhapur, our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a safe and comfortable travel experience. With experienced chauffeurs, flexible one-way or round-trip options, and 24/7 booking assistance, we make intercity travel stress-free and affordable. From Hinjewadi to Kharadi, Baner to Hadapsar, Aaryan Travels provides doorstep pickup and reliable outstation cabs across Pune for individuals, families, and corporate travelers alike.',

    top: 'Top Places to Visit in Bangalore with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal artifacts and photographs. Its sprawling gardens and Italian arches make it a peaceful retreat. It also houses the samadhis of Kasturba Gandhi and Mahadev Desai. Aga Khan Palace is Pune’s symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for its charitable work. Devotees find immense peace and blessings here. Dagdusheth Ganpati is the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings are a testament to early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a major attraction. The museum is Pune’s living archive of art and craftsmanship."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and transformation. Osho Ashram is Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature. It is Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during monsoon. Street vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends and sunsets."
  }
],



"services": [
  {
    "name": "Outstation Cab Bookings in Pune",
    "description": "Outstation Cab Bookings in Pune provide reliable and comfortable transportation for long-distance travel from Pune to various cities. Perfect for business trips, family vacations, or weekend getaways, this service ensures timely pickups, well-maintained vehicles, and professional chauffeurs familiar with all major routes. Customers can book SUVs, sedans, or luxury cars tailored to their travel needs, with flexible booking options including one-way and round trips."
  },
  {
    "name": "Pune Intercity Taxi",
    "description": "Pune Intercity Taxi service specializes in convenient and affordable travel between Pune and neighboring cities. Designed for frequent travelers and tourists, it offers door-to-door service with punctual pickups and drop-offs. The fleet includes a variety of vehicles suited for solo travelers, families, and corporate clients."
  },
  {
    "name": "Long Distance Cab Pune",
    "description": "Long Distance Cab Pune offers comfortable and safe rides for journeys extending beyond city limits. With professional drivers trained for extended trips, this service focuses on traveler safety, timely arrivals, and hassle-free booking. Ideal for business travelers and leisure seekers looking for reliable transport over long distances."
  },
  {
    "name": "Pune to Other City Cab",
    "description": "Pune to Other City Cab service provides dedicated transportation to various cities across Maharashtra and beyond. With options for hourly or daily rentals, customers enjoy the flexibility to plan trips as per their schedules, supported by experienced chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Round Trip Cab Pune",
    "description": "Round Trip Cab Pune caters to travelers needing return journeys from Pune to nearby cities or tourist destinations. The service includes pre-scheduled pickup and drop timings, ensuring a seamless and stress-free travel experience with transparent pricing and excellent customer support."
  },
  {
    "name": "One-Way Cab Pune",
    "description": "One-Way Cab Pune is ideal for travelers who require transportation in a single direction without the need for return. This service is popular for airport transfers, relocation, and business trips, providing efficient and affordable travel options with quality service."
  },
  {
    "name": "Pune Outstation Travel Cab",
    "description": "Pune Outstation Travel Cab focuses on providing smooth and comfortable journeys for travelers venturing outside Pune. With a variety of vehicle choices and well-trained chauffeurs, this service is tailored to meet the demands of both leisure and corporate travelers, ensuring a pleasant travel experience."
  },
  {
    "name": "Affordable Outstation Taxi Pune",
    "description": "Affordable Outstation Taxi Pune offers budget-friendly long-distance cab services without compromising on quality or comfort. Perfect for travelers seeking economical options for outstation journeys, the service maintains a high standard of vehicles and customer care."
  },
  {
    "name": "Chauffeur Driven Outstation Cab Pune",
    "description": "Chauffeur Driven Outstation Cab Pune provides premium chauffeur services for outstation trips, emphasizing professionalism, safety, and customer convenience. The chauffeurs are skilled in managing long-distance drives while ensuring the passenger’s comfort and timely arrival."
  },
  {
    "name": "Best Outstation Cab Pune",
    "description": "Best Outstation Cab Pune is known for its superior vehicle fleet, punctual service, and customer satisfaction. Offering a range of cars from sedans to SUVs, this service is a preferred choice for hassle-free intercity travel."
  },
  {
    "name": "SUV for Outstation Pune",
    "description": "SUV for Outstation Pune caters to groups or families requiring spacious and comfortable vehicles for long-distance travel. Equipped with modern amenities and safety features, these SUVs ensure a smooth and enjoyable ride even on extended trips."
  },
  {
    "name": "Sedan Outstation Hire Pune",
    "description": "Sedan Outstation Hire Pune provides elegant and efficient sedans for travelers looking for a blend of comfort and economy on outstation journeys. These sedans are well-maintained and come with experienced chauffeurs for a relaxed travel experience."
  },
  {
    "name": "Corporate Outstation Cab Pune",
    "description": "Corporate Outstation Cab Pune specializes in providing professional and timely transport solutions for business travelers heading out of Pune. The service offers premium vehicles and chauffeur expertise to meet corporate standards for intercity travel."
  },
  {
    "name": "Online Outstation Cab Booking Pune",
    "description": "Online Outstation Cab Booking Pune simplifies the reservation process for outstation travel with an easy-to-use digital platform. Customers can check availability, choose vehicle types, and make instant bookings with secure payment options."
  },
  {
    "name": "Weekend Trip Cab Pune",
    "description": "Weekend Trip Cab Pune is designed for travelers planning short leisure trips outside the city during weekends. The service offers flexible booking, comfortable vehicles, and knowledgeable chauffeurs to ensure a relaxing and enjoyable weekend getaway."
  }
],
"tableData": [
  ["Outstation Cab Bookings in Pune", "Pune Intercity Taxi"],
  ["Long Distance Cab Pune", "Pune to Other City Cab"],
  ["Round Trip Cab Pune", "One-Way Cab Pune"],
  ["Pune Outstation Travel Cab", "Affordable Outstation Taxi Pune"],
  ["Chauffeur Driven Outstation Cab Pune", "Best Outstation Cab Pune"],
  ["SUV for Outstation Pune", "Sedan Outstation Hire Pune"],
  ["Corporate Outstation Cab Pune", "Online Outstation Cab Booking Pune"],
  ["Weekend Trip Cab Pune", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Outstation Cab Bookings in Pune",
    "WhyChoosedescription": "Aaryan Travels provides reliable outstation cab bookings in Pune, perfect for weekend getaways, business trips, and long-distance travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned cabs that are regularly serviced for your comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Skilled in Long-Distance Routes",
    "WhyChoosedescription": "Our professional drivers are knowledgeable about major outstation routes, ensuring smooth and timely journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Benefit from clear, all-inclusive pricing that covers fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Outstation Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans suited for your outstation travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to ensure a healthy travel environment."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee timely pickups and drop-offs for a hassle-free outstation travel experience."
  }
]



























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer outstation cab bookings in Pune?',
    answer: 'Yes, Aaryan Travels provides reliable outstation cab booking services from Pune to various destinations across India.',
  },
  {
    question: 'How can I book outstation cabs in Pune with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Pune.',
  },
  {
    question: 'What types of vehicles are available for outstation cab bookings in Pune?',
    answer: 'Aaryan Travels offers a range of well-maintained sedans, SUVs, and luxury cars suitable for outstation travel from Pune.',
  },
  {
    question: 'Are drivers experienced and trained for outstation cab bookings from Pune?',
    answer: 'Absolutely. Our drivers are licensed, punctual, and professionally trained to ensure a safe and comfortable journey.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for outstation bookings from Pune?',
    answer: 'Yes, you can specify preferred pickup and drop-off points within Pune and your outstation destination.',
  },
  {
    question: 'Is the outstation cab booking service available 24x7 in Pune?',
    answer: 'Yes, Aaryan Travels offers round-the-clock outstation cab booking services to fit your travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for outstation cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene guidelines for your well-being.',
  },
  {
    question: 'What payment options are accepted for outstation cab bookings in Pune?',
    answer: 'We accept payments via corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available during the outstation cab booking period in Pune?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your outstation travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Karan Joshi',
    feedback: 'Aaryan Travels made our outstation trip from Pune smooth and comfortable with their excellent cab service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Reliable and professional outstation cab bookings from Pune by Aaryan Travels. Highly recommend their services.',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const outstationCabPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Outstation Cab Bookings in Pune",
  "description": "Aaryan Travels offers reliable outstation cab bookings in Pune. Travel long distances comfortably with chauffeur-driven SUVs and sedans for corporate and personal trips at affordable prices.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Outstation Cab Service",
  "keywords": "Outstation Cab Bookings in Pune, Pune Intercity Taxi, Long Distance Cab Pune, Pune to Other City Cab, Round Trip Cab Pune, One-Way Cab Pune, Pune Outstation Travel Cab, Affordable Outstation Taxi Pune, Chauffeur Driven Outstation Cab Pune, Best Outstation Cab Pune, SUV for Outstation Pune, Sedan Outstation Hire Pune, Corporate Outstation Cab Pune, Online Outstation Cab Booking Pune, Weekend Trip Cab Pune"
};





  return (
    <div>


<Helmet>
  <title>Outstation Cab Bookings in Pune | Reliable Intercity Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Book outstation cabs in Pune with Aaryan Travels for long distance trips. Affordable chauffeur-driven SUVs and sedans available for corporate and weekend travel."
  />
  <meta
    name="keywords"
    content="Outstation Cab Bookings in Pune, Pune Intercity Taxi, Long Distance Cab Pune, Pune to Other City Cab, Round Trip Cab Pune, One-Way Cab Pune, Pune Outstation Travel Cab, Affordable Outstation Taxi Pune, Chauffeur Driven Outstation Cab Pune, Best Outstation Cab Pune, SUV for Outstation Pune, Sedan Outstation Hire Pune, Corporate Outstation Cab Pune, Online Outstation Cab Booking Pune, Weekend Trip Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(outstationCabPuneSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/87.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationcabbookinginpune;